import { cn } from "@/lib/utils";

/**
 * Shared typography + shells for Class info / Customer info modals and aligned lists.
 * Attribute values align with chat bubble body text (MarkdownContent variant="chat").
 */

/** Chat bubble / markdown body text color — shared with MarkdownContent. */
export const chatBodyTextColorClassName = "text-[#1F1F1F]";

/** Section/category titles in right-hand info panels (About, Clients, filter sheet sections). */
export const infoPanelSectionLabelClassName =
  "text-[11px] font-medium uppercase tracking-wide text-muted-foreground";

export const modalAttrValueClassName = cn(
  "text-sm font-normal leading-normal",
  chatBodyTextColorClassName,
);

/** Primary line inside a muted box (same main body tone as chat messages). */
export const modalListPrimaryLineClassName = cn(
  "text-sm font-normal leading-normal",
  chatBodyTextColorClassName,
);

/** Caption / secondary line under a list title in muted boxes. */
export const modalListCaptionClassName =
  "text-sm font-normal text-muted-foreground leading-normal";

/** Gray list row container (upcoming schedule, customer classes, etc.). */
export const modalMutedListBoxClassName = "rounded-lg bg-muted/40 px-3 py-2";

/**
 * Studio Data section titles: Policies policy titles, General Info block titles,
 * FAQ question titles (same size/weight as Policies h4).
 */
export const studioSectionTitleClassName =
  "text-[16px] font-semibold text-foreground leading-snug";

/** Tab label size/line-height for Settings + Studio Data horizontal tabs (font-medium → active:semibold). */
export const horizontalNavTabTitleClassName = "text-sm leading-5";
